import { type RouteDefinition } from "../../shared/types/routes";
import RoleGuard from "../../core/guards/RoleGuard";
import UserList from "./UserList";

export const usersRoutes: RouteDefinition[] = [
  {
    path: "/users",
    element: (
      <RoleGuard roles={["admin", "user_manager"]}>
        <UserList />
      </RoleGuard>
    ),
  },
];
